<template>
    <div class="item_lunbo">
        <div class="item-title">
            <h3 class="title2 fz40">合作机构</h3>
        </div>
        <div class="item-contents center">
            <div class="lunbo">
                <a-carousel arrows autoplay>
                    <div class="lunbo-div" v-for="(x,n) in item_lunbo">
                        <ul>
                            <li v-for="(y,m) in x">
                                <img :src="y.image" alt="">
                            </li>
                        </ul>
                    </div>
                    <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: -100px;zIndex: 1">
                        <a-icon type="left-circle" />
                    </div>
                    <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: -100px">
                        <a-icon type="right-circle" />
                    </div>
                </a-carousel>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: "lunbo",
        data() {
            return {
                start: 1,
                item_lunbo: [],
            }
        },
        created() {

        },
        mounted() {
            var arr = [],ind = 0;
            for(var i = 0,len = 6; i<len;i++){
                arr[i] = [];
                var count = 1;
                for(var j = 0,len_ = 12; j<len_;j++){
                    ind = ind+count;
                    arr[i].push({image:"static/img/common/logo/customer/"+(ind+"")+".png"});
                }
            }
            this.item_lunbo = arr;
        },
        methods: {
            // toLeft() {
            //         if (this.start == 3) {
            //             this.start = 0;
            //             this.$refs.lunbo_.style.left = 0;
            //         } else {
            //             this.$refs.lunbo_.style.left = -(this.start * 970) + "px";
            //         }
            //         this.start++;
            //     },
            //     toRight() {
            //         if (this.start == 1) {
            //             // this.start = 3;
            //             // this.$refs.lunbo_.style.left=-(this.start-1)*970+"px";
            //         } else {
            //             this.start--;
            //             this.$refs.lunbo_.style.left = -(this.start - 1) * 970 + "px";
            //         }
            //     },
        }
    }
</script>

<style scoped lang="less">
    /deep/.ant-carousel {
        .slick-prev,
        .slick-next {
            width: 54px;
            height: 124px;
            position: absolute;
            top: 124px;
            cursor: pointer;
        }

        .slick-prev,.slick-prev:hover,.slick-prev:focus {
            background: url(/static/img/common/jiantou.png) no-repeat center !important;
            transform: rotate(-180deg);
        }

        .slick-next,.slick-next:hover,.slick-next:focus {
            background: url(/static/img/common/jiantou.png) no-repeat center !important;
        }

        .slick-dots,
        .slick-dots-bottom {
            display: none !important;
        }

        .custom-slick-arrow:before {
            display: none;
        }

        .custom-slick-arrow:hover {
            opacity: 0.5;
        }
    }

    .item_lunbo {
        width: 100%;
        height: 665px;
        background: url("/static/img/home/item_5_bg.jpg") no-repeat center;
        padding: 80px 0 110px;

        .title2 {
            color: #fff;
            margin: 0;
        }

        .item-contents {
            padding: 0 40px;
            margin-top: 50px;
            position: relative;

            /* .button {
                width: 50px;
                height: 120px;
                border: 2px solid #FFFFFF;
                position: absolute;
                top: 124px;
                cursor: pointer;

                &.left {
                    left: 0;
                }

                &.right {
                    right: 0;
                }
            } */

            .lunbo {
                width: 970px;
                height: 368px;
                /* overflow: hidden; */
                margin: 0 auto;
                position: relative;

                /* >ul {
                    transition: 1s;
                    width: 3000px;
                    position: absolute;
                    top: 0;
                    left: 0; */

                .lunbo-div {
                    float: left;
                    overflow: hidden;
                    width: 970px;
                    height: 368px;

                    >ul {
                        width: 970px;
                        height: 368px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: space-between;

                        >li {
                            width: 240px;
                            height: 120px;
                            border: 1px solid;
                            background: #fff;
                            overflow: hidden;

                            img {
                                margin: 0 auto;
                                width: 100%;
                                object-fit: cover;
                            }
                        }
                    }
                }

                /* } */
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/lunbo.vue